import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { testSimplifiedBaBAnalytics } from 'analytics/events';

const { NODE_ENV } = process.env;

export const useStatsigExperienceAnalytics = () => {
  useEffect(() => {
    try {
      const cookieValue = Cookies.get('simplifiedBaBGroupName') || '';

      if (cookieValue === 'Test' || cookieValue === 'Control') {
        testSimplifiedBaBAnalytics({
          test_variant: cookieValue
        });
      }

      Cookies.remove('simplifiedBaBGroupName', { sameSite: 'lax' });
    } catch (error) {
      if (NODE_ENV !== 'production')
        // eslint-disable-next-line no-console
        console.error('Error parsing analytics data', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
